module.exports = __webpack_public_path__ + "static/media/BB_buildings.dc1e2775.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/BB_buildings.png
// module id = 703
// module chunks = 0